<style scoped lang="scss" type="text/scss">
    .square-info-block-container {
        width: 12rem;
        height: 5rem;
        box-sizing: border-box;
        background-color: #F4F4F4;
        color: #AAA;
        border: .1rem solid transparent;
        padding: .7rem 1rem .8rem;

        .top-panel, .bottom-panel {
            display: flex;
            align-items: center;
        }

        .top-panel {
            height: 2rem;
            font-size: .85rem;
            color: #888;

            .main-competition-icon {
                margin-right: .5rem;
                color: #FD9A05;
            }
        }

        .bottom-panel {
            height: 1.5rem;
            font-size: .75rem;
            justify-content: space-between;
        }
    }
</style>

<template>
    <angle-hover-card class="square-info-block-container" :class="{'active': active}" :active="active">
        <div class="top-panel">
            <i class="icon main-competition-icon" title="主赛事" v-if="isMain">&#xe61b;</i>
            <span class="global-text-ellipsis">{{ name }}</span>
        </div>
        <div class="bottom-panel">
            <span>{{ year }}</span>
            <competition-status-led :status="status"></competition-status-led>
        </div>
    </angle-hover-card>
</template>

<script>
    import AngleHoverCard from '../../../components/angle-hover-card/index';
    import CompetitionStatusLed from '../../sub-components/competition-status-led/index';

    export default {
        name: '',
        components: {
            AngleHoverCard,
            CompetitionStatusLed
        },
        props: {
            active: {
                type: Boolean,
                default: false
            },
            status: {
                type: String,
                default: ''
            },
            name: {
                type: String,
                default: null
            },
            year: {
                type: String | Number,
                default: null
            },
            isMain: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {};
        }
    };
</script>
